// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader-module__wrapper___hvFtT","lds-ring":"Loader-module__lds-ring___L6xj2"};